import { apiFetch } from './api'

export type TeamMember = {
  userId: string
  name: string
  email: string
  role: 'admin' | 'editor'
  modules: Array<'knowledge' | 'support' | 'crm'>
  createdAt: string
}

function workspaceQuery(workspaceId: string) {
  return `workspaceId=${encodeURIComponent(workspaceId)}`
}

export async function getTeamMembers(workspaceId: string) {
  return apiFetch<TeamMember[]>(`/api/team/members?${workspaceQuery(workspaceId)}`)
}

export async function inviteMember(
  workspaceId: string,
  payload: { email: string; role: 'admin' | 'editor' },
) {
  return apiFetch<TeamMember>(`/api/team/invite?${workspaceQuery(workspaceId)}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function removeMember(workspaceId: string, userId: string) {
  return apiFetch<{ removed: boolean }>(
    `/api/team/members/${userId}?${workspaceQuery(workspaceId)}`,
    { method: 'DELETE' },
  )
}
